/* Pet Cameo | v34 | Production date: 2026-10-02 | Matt Font-AI-ne */
// No JS? Keep the damn navigation usable.
(() => {
    'use strict';
    const menuButton = document.querySelector('.menu-toggle');
    const navigation = document.querySelector('.header-nav');
    if (!menuButton || !navigation) return;
    document.documentElement.classList.add('js');
    function closeMenu() {
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open menu');
      navigation.classList.remove('is-open');
    }
    menuButton.addEventListener('click', () => {
      const expanded = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!expanded));
      menuButton.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
      navigation.classList.toggle('is-open', !expanded);
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menuButton.getAttribute('aria-expanded') === 'true') {
        closeMenu();
        menuButton.focus();
      }
    });
    window.matchMedia('(min-width: 761px)').addEventListener('change', closeMenu);
})();

// One count. All cart badges.
(() => {
  function updateCartCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('.cart-count').forEach(badge => {
      const number = document.createElement('span');
      number.className = 'cart-count-number';
      number.textContent = count;
      badge.replaceChildren(number);
      badge.hidden = count === 0;
      badge.closest('a')?.setAttribute('aria-label', `View cart, ${count} items`);
    });
    try { sessionStorage.setItem('petcameo:cart-count', String(count)); } catch {}
  }
  window.addEventListener('petcameo:cart-updated', event => updateCartCount(event.detail?.cartCount));
  const header = document.querySelector('[data-cart-count]');
  if (header) updateCartCount(Number(header.dataset.cartCount));
})();

// Shop needs artwork. No artwork yet, no Shop link.
(() => {
    'use strict';
    const links = document.querySelectorAll('.header-nav a[href$="/pages/shop"], .footer-links a[href$="/pages/shop"]');
    if (!links.length) return;
    function hasArtwork() {
      try { return !!JSON.parse(sessionStorage.getItem('petcameo:artwork') || 'null'); } catch { return false; }
    }
    function sync() {
      const enabled = hasArtwork();
      links.forEach(link => {
        link.classList.toggle('is-disabled', !enabled);
        if (enabled) { link.removeAttribute('aria-disabled'); link.removeAttribute('tabindex'); link.removeAttribute('title'); }
        else { link.setAttribute('aria-disabled', 'true'); link.tabIndex = -1; link.title = 'Create your artwork first'; }
      });
    }
    links.forEach(link => link.addEventListener('click', event => { if (!hasArtwork()) event.preventDefault(); }));
    window.addEventListener('petcameo:artwork-ready', sync);
    window.addEventListener('pageshow', sync);
    sync();
})();

// Checkout button on Shop: grey until the cart has something in it.
(() => {
  const button = document.getElementById('shop-checkout');
  if (!button) return;
  function sync(count) {
    const enabled = count > 0;
    button.setAttribute('aria-disabled', String(!enabled));
    button.tabIndex = enabled ? 0 : -1;
  }
  button.addEventListener('click', event => { if (button.getAttribute('aria-disabled') === 'true') event.preventDefault(); });
  window.addEventListener('petcameo:cart-updated', event => { if (Number.isInteger(event.detail?.cartCount)) sync(event.detail.cartCount); });
  window.addEventListener('pageshow', () => { const header = document.querySelector('[data-cart-count]'); if (header) sync(Number(header.dataset.cartCount)); });
  const header = document.querySelector('[data-cart-count]');
  sync(header ? Number(header.dataset.cartCount) : 0);
})();
